import React from 'react';
import { Content } from './Content';
import { OWASProvider } from './context';
import type { Parameters } from './types';

interface OWASReportProps {
	defaultParameters: Partial<Parameters>;
	onClose: () => void;
}

export function OWASReport({ defaultParameters, onClose }: Readonly<OWASReportProps>): JSX.Element {
	return (
		<OWASProvider defaultParameters={defaultParameters} onClose={onClose}>
			<Content />
		</OWASProvider>
	);
}
